window.app.controller('compareController', ['$scope', '$http', '$compile', '$mdDialog', function ($scope, $http, $compile, $mdDialog) {
    $scope.referrerLink = () => {
        return document.referrer
    };
    $scope.nestedCategories = {
        'konto': ['konto-mlodziezowe', 'konto-osobiste', 'konto-oszczednosciowe']
    }
    $scope.category = window.location.pathname.split('/')[1];
    $scope.setUrl = (url) => {
        window.history.pushState('offers', 'Title', '?' + url);
    };
    $scope.nameOfCopare = window.location.pathname.split('/')[1].toUpperCase();
    $scope.newCategoryOffers = function (itemParams) {
        console.log($scope.grid.offers); /*this 'id' will be ignore*/
        var offers = $scope.grid.offers;
        var newOffers = [];
        var ignoreOffer = {
            id: itemParams.id,
            amount: itemParams.requestedAmount,
            term: itemParams.requestedTerm + ':' + itemParams.termDivider
        };

        for (var i = 0; i < offers.length; i++) {
            if (
                ignoreOffer.id == offers[i].id &&
                ignoreOffer.amount == offers[i].requestedAmount &&
                ignoreOffer.term == offers[i].requestedTerm) {
            } else {
                {
                    newOffers.push({
                        id: offers[i].id,
                        amount: offers[i].requestedAmount,
                        term: (offers[i].requestedTerm + ':' + itemParams.termDivider)
                    });

                }
            }
        }
        return newOffers;

    };

    $scope.remove = {
        offersItem: (index, params) => {
            $scope.grid.offers.splice(index, 1);
            let cl = $scope.compareList.list.get() || {};
            let category = $scope.category

            let offersListUpdate = () => {
                cl[category] = $scope.newCategoryOffers(params);
                if (cl[category].length) {
                    $scope.compareList.list.set(cl);
                    $scope.compareList.createLink();
                    let links = $scope.compareList.data.links;
                    for (let i = 0; i < links.length; i++) {
                        if (links[i].ttl === category) $scope.setUrl(links[i].url);
                    }
                } else {
                    delete cl[category];
                    $scope.compareList.list.set(cl);
                    $scope.compareList.createLink();
                    $scope.setUrl('');
                }
                ;
            };
            offersListUpdate()
        },
        offersAll: () => {
            $scope.grid.offers = [];
            let cl = $scope.compareList.list.get() || {};
            delete cl[$scope.category];
            $scope.compareList.list.set(cl);
            $scope.compareList.createLink();
            $scope.setUrl('')
        }
    };

    $scope.reloadOffers = () => {
        window.onpopstate = (event) => {
            window.location.href = window.location.href
        }
    };
    $scope.reloadOffers();
    $scope.checkType = (val) => typeof val;

    $scope.upadeCpTableItemsHeight = () => {
        let titles = $('.offer-prop-title');
        for (let i = 0; i < titles.length; i++) {
            $(`.prop-index-${i}`).css('height', titles[i].clientHeight + '');
        }
    };

    $scope.scrollCpTable = (side) => {
        let logos = $('.offers-logos');
        let props = $('.offers-props');
        let propWidth = $('.offers-props__item')[0].clientWidth;
        if (side === 'left') {
            logos.scrollLeft(logos.scrollLeft() - propWidth);
            props.scrollLeft(props.scrollLeft() - propWidth);
        }
        if (side === 'right') {
            logos.scrollLeft(logos.scrollLeft() + propWidth);
            props.scrollLeft(props.scrollLeft() + propWidth);
        }
    };

    $scope.propItemFocus = (i) => {
        $('.cp__offer-prop-val, .offer-prop-title').removeClass('focus');
        $(`.prop-index-${i}`).addClass('focus')
    };

    $scope.offerItemFocus = (i) => {
        $('.offers-logos__item, .offers-props__item').removeClass('focus');
        $(`.offers-logos__item.index-${i}`).addClass('focus');
        $(`.offers-props__item.index-${i}`).addClass('focus');
    };

    $scope.propItemFixedFocus = (id) => {
        if ($(`.prop-index-${id}`).hasClass('fixed-focus')) {
            $(`.prop-index-${id}`).removeClass('fixed-focus')
        } else {
            $(`.prop-index-${id}`).addClass('fixed-focus')
        }
    }

    $scope.generatePath = () => {
        let nestedCat = $scope.category.split('-')[0];
        if ($scope.nestedCategories[nestedCat] && $scope.nestedCategories[nestedCat].includes($scope.category)) {
            return `/${nestedCat}/${$scope.category}`
        } else {
            return `/${$scope.category}`
        }
    }
    $scope.isOverflown = (element) => {
        return element[0].scrollHeight > element[0].clientHeight;
    }

    $scope.fixWidth = () => {
        let isOverflow = $scope.isOverflown($(".cp-table__body"));
        if (!isOverflow) {
            $(".offers-logos").css({ 'max-width': '100%', 'margin-left': '0'})
        }
    }

    $('.offers-props').scroll(function () {
        var w = $(this).scrollLeft()
        $('.offers-logos').scrollLeft(w)
    })
    $(document).ready(() => {
        setTimeout(function () {
            $scope.upadeCpTableItemsHeight();
            $scope.fixWidth();
        }, 0)

    })
}]);


// WEBPACK FOOTER //
// src/js/controllers/offers/compareController.js